export function CampaignTableMock() {
  return (
    <div className="space-y-2">
      {Array.from({ length: 6 }).map((_, i) => (
        <div key={i} className="flex items-center justify-between border-b py-2 last:border-b-0">
          <div className="flex items-center gap-3">
            <div className="h-2 w-2 rounded-full bg-rose-400" />
            <div className="h-3 w-40 rounded bg-slate-200" />
            <div className="h-5 w-12 rounded-full bg-amber-100" />
          </div>
          <div className="flex items-center gap-6">
            <div className="h-3 w-12 rounded bg-slate-200" />
            <div className="h-3 w-16 rounded bg-slate-200" />
            <div className="h-3 w-20 rounded bg-slate-200" />
            <div className="h-3 w-14 rounded bg-slate-200" />
          </div>
        </div>
      ))}
    </div>
  );
}

export function TrendChartMock() {
  return (
    <div className="flex h-40 items-end gap-2">
      {[40, 65, 50, 80, 55, 90, 70, 60, 75, 85, 65, 50, 70, 80, 95, 60, 55, 75].map((h, i) => (
        <div
          key={i}
          className="flex-1 rounded-t bg-gradient-to-t from-rose-300 to-pink-400"
          style={{ height: `${h}%` }}
        />
      ))}
    </div>
  );
}

export function CampaignDetailMock() {
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-2 gap-4 sm:grid-cols-4">
        {Array.from({ length: 4 }).map((_, i) => (
          <div key={i} className="space-y-1">
            <div className="h-3 w-24 rounded bg-slate-200" />
            <div className="h-5 w-16 rounded bg-slate-300" />
          </div>
        ))}
      </div>
      <div className="space-y-2">
        {Array.from({ length: 5 }).map((_, i) => (
          <div key={i} className="flex items-center justify-between">
            <div className="h-3 w-32 rounded bg-slate-200" />
            <div className="h-3 w-20 rounded bg-slate-200" />
          </div>
        ))}
      </div>
    </div>
  );
}

export function SummaryMock() {
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-4">
        {[
          { label: "Total discounted", value: "$12,480" },
          { label: "Redemptions", value: "342" },
          { label: "Unique customers", value: "189" },
          { label: "Average discount", value: "$36.50" },
        ].map((card) => (
          <div key={card.label} className="rounded-lg border bg-card p-3">
            <div className="text-xs text-muted-foreground">{card.label}</div>
            <div className="mt-1 text-lg font-semibold">{card.value}</div>
          </div>
        ))}
      </div>
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-3">
        {[
          { label: "Discounted appointment rate", value: "28.4%" },
          { label: "New customer share", value: "41%" },
          { label: "Average order value (with discount)", value: "$78.20" },
        ].map((card) => (
          <div key={card.label} className="rounded-lg border bg-card p-3">
            <div className="text-xs text-muted-foreground">{card.label}</div>
            <div className="mt-1 text-base font-semibold">{card.value}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

export function SalonBreakdownMock() {
  return (
    <div className="space-y-2">
      {Array.from({ length: 4 }).map((_, i) => (
        <div key={i} className="flex items-center justify-between border-b py-2 last:border-b-0">
          <div className="flex items-center gap-3">
            <div className="h-3 w-32 rounded bg-slate-200" />
          </div>
          <div className="flex items-center gap-6">
            <div className="h-3 w-12 rounded bg-slate-200" />
            <div className="h-3 w-16 rounded bg-slate-200" />
            <div className="h-3 w-20 rounded bg-slate-200" />
          </div>
        </div>
      ))}
    </div>
  );
}
